export const GET_WORKOUT_SUCCEED = 'Client/GET_WORKOUT_SUCCEED';
export const GET_WORKOUT_ERROR = 'Client/GET_WORKOUT_ERROR';
export const LOADING_STATE = 'Client/LOADING_STATE';
export const CREATE_WORKOUT_LOG_SUCCEED = 'Client/CREATE_WORKOUT_LOG_SUCCEED';
export const CREATE_WORKOUT_LOG_ERROR = 'Client/CREATE_WORKOUT_LOG_SUCCEED';
export const GET_WORKOUT_LAST_LOG_SUCCESS = 'Client/GET_WORKOUT_LAST_LOG_SUCCESS';
export const GET_WORKOUT_LAST_LOG_ERROR = 'Client/GET_WORKOUT_LAST_LOG_ERROR';
export const GET_WORKOUT_LOG_SUCCESS = 'Client/GET_WORKOUT_LOG_SUCCESS';
export const GET_WORKOUT_LOG_ERROR = 'Client/GET_WORKOUT_LOG_ERROR';
export const LOADING_LAST_LOGGED_WORKOUT = 'Client/LOADING_LAST_LOGGED_WORKOUT';